import React from 'react';

import sav_head from './sav_head.svg';
import jasper_head from './jasper_head.svg';
import mom_head from './mom_head.svg';
import cyrus_head from './cyrus_head.svg';
import ruby_head from './ruby_head.svg';
import dad_head from './dad_head.svg';
import family_pic from './family_pic.svg';
import julerrio_head from './julerrio_head.svg';

import './HeadPages.css';
import EmilyHome from './pages/EmilyHome';

function LogoPage({ img, hostname }) {
  return (
    <div className="App">
      <header className="App-header">
        {img && <img src={img} className="App-logo" alt="logo" />}
        <p>{hostname}</p>
      </header>
    </div>
  );
}

export default function HeadPages() {
  const host = window.location.hostname;

  switch (host) {
    case 'emilymabey.com':
      return <EmilyHome />;
    
    case 'localhost':
      return <EmilyHome />;

    case 'savannahswensen.com':
      return <LogoPage img={sav_head} hostname={host} />;

    case 'jasperswensen.com':
      return <LogoPage img={jasper_head} hostname={host} />;

    case 'cyrusswensen.com':
      return <LogoPage img={cyrus_head} hostname={host} />;

    case 'rubyswensen.com':
      return <LogoPage img={ruby_head} hostname={host} />;

    case 'stevepswensen.com':
      return <LogoPage img={dad_head} hostname={host} />;

    case 'swensen5.com':
      return <LogoPage img={family_pic} hostname={host} />;

    case 'julerrioswensen.com':
    case 'julerriomcgruder.com':
      return <LogoPage img={julerrio_head} hostname={host} />;

    default:
      return <LogoPage hostname={host} />;
  }
}
